import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-tekme',
  templateUrl: './tekme.component.html',
  styleUrls: ['./tekme.component.scss']
})
export class TekmeComponent implements OnInit {
  competitions: any[] = [];
  loading = false;
  error: string | null = null;
  showAddDialog = false;
  showEditDialog = false;
  editCompetition: any = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadCompetitions();
  }

  loadCompetitions(): void {
    const apiUrl = 'https://testapi.ovh/api/strelstvo/competitions';
    this.loading = true;
    this.error = null;

    const token = localStorage.getItem('access_token');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const unitId = localStorage.getItem('unit_id');
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.get<any[]>(apiUrl, { headers, params }).subscribe(
      (data) => {
        this.competitions = data;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching competitions:', error);
        this.competitions = [];
        this.loading = false;
        this.error = 'Napaka pri nalaganju tekmovanj!';
      }
    );
  }

  onAdd(competition: any) {
    this.showAddDialog = false;
    this.loadCompetitions();
  }

  isTeilerCompetition(competition: any): boolean {
    return competition?.is_teiler === true || Number(competition?.is_teiler) === 1;
  }

  onEdit(competition: any) {
    let date = competition.competition_date;
    if (date) {
      // If it's a Date string like "Fri, 27 Jun 2025 00:00:00 GMT"
      const parsed = new Date(date);
      if (!isNaN(parsed.getTime())) {
        // Format to yyyy-MM-dd
        const yyyy = parsed.getFullYear();
        const mm = String(parsed.getMonth() + 1).padStart(2, '0');
        const dd = String(parsed.getDate()).padStart(2, '0');
        date = `${yyyy}-${mm}-${dd}`;
      }
    }

    console.log('competition_date before:', competition.competition_date, 'after:', date);

    this.editCompetition = {
      ...competition,
      competition_date: date
    };
    this.showEditDialog = true;
  }

  onEditSave(updated: any) {
    this.showEditDialog = false;
    this.loadCompetitions();
  }
}